/* ejemplo
export const navigation: NavGroup[] = [
{
    title: 'PAGES',
    items: [
      { icon: 'person', title: 'Profile', route: '/profile' },
      {
        icon: 'manage_accounts',
        title: 'User Management',
        route: '/users',
        children: [
          { title: 'All Users', route: '/users/list' },
          { title: 'Roles', route: '/users/roles' },
          { title: 'Permissions', route: '/users/permissions' },
        ],
      },
      { icon: 'settings', title: 'Settings', route: '/settings' },
      { icon: 'receipt_long', title: 'Invoices', route: '/invoices' },
      { icon: 'help_outline', title: 'FAQ', route: '/faq' },
    ],
  },
  {
    title: 'EXTRAS',
    items: [
      {
        icon: 'account_tree',
        title: 'Menu Levels',
        route: '/menu',
        children: [
          { title: 'Level 2.1', route: '/menu/2-1' },
          { title: 'Level 2.2', route: '/menu/2-2' },
        ],
      },
    ],
  }
]
*/

import { ROLES } from '../constants/user.const';

export interface NavChild {
  title: string;
  route: string;
  roles?: ROLES[];
}

export interface NavItem {
  icon: string;
  title: string;
  route: string;
  roles?: ROLES[];
  children?: NavChild[];
}

export interface NavGroup {
  title: string;
  items: NavItem[];
  roles?: ROLES[];
}

export const navigation: NavGroup[] = [
  {
    title: 'Inicio',
    items: [{ icon: 'dashboard', title: 'Dashboard', route: '/' }],
    // Sin roles → visible para todos los autenticados
  },

  {
    title: 'Alertas',
    // roles: [ROLES.OPERADOR_911],
    items: [
      {
        icon: 'list',
        title: 'Listar',
        route: '/alerts/list',
        // roles: [ROLES.OPERADOR_911],
      },
    ],
  },

  {
    title: 'Chats',
    // roles: [ROLES.OPERADOR_911],
    items: [
      {
        icon: 'chat',
        title: 'Listar',
        route: '/chats/list',
        // roles: [ROLES.OPERADOR_911],
      },
    ],
  },

  {
    title: 'Usuarios',
    // roles: [ROLES.OPERADOR_911],
    items: [
      {
        icon: 'list',
        title: 'Listar',
        route: '/users/list',
        // roles: [ROLES.OPERADOR_911],
      },
      {
        icon: 'add',
        title: 'Crear',
        route: '/users/new',
        // roles: [ROLES.OPERADOR_911],
      },
      {
        icon: 'schedule',
        title: 'A expirar',
        route: '/users/expire',
        // roles: [ROLES.OPERADOR_911],
      },
    ],
  },

  {
    title: 'Instituciones',
    // roles: [ROLES.OPERADOR_911],
    items: [
      {
        icon: 'list',
        title: 'Listar',
        route: '/institutions/list',
        // roles: [ROLES.OPERADOR_911],
      },
      {
        icon: 'add',
        title: 'Crear',
        route: '/institutions/new',
        // roles: [ROLES.OPERADOR_911],
      },
    ],
  },
];
